















import {
  defineComponent,
  PropType,
  ref,
  computed,
} from '@nuxtjs/composition-api';
import { BaseBanner } from '@bambeehr/pollen';
import { fetchContent } from '@/modules/OnboardingWizard/utils/copy';
import launchDarkly from '@bambeehr/vue-launch-darkly';

export default defineComponent({
  name: 'CompanyInfo',
  components: {
    BaseBanner,
  },
  props: {
    // Entry ID for banner content lookup
    entryId: {
      type: String as PropType<string>,
      required: true,
    },
    ldFlagId: {
      type: String as PropType<string>,
      default: '',
    },
    showClose: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props, { emit }) {
    const showBanner = ref(false);
    const message = ref();
    const description = ref();
    const variant = ref();
    const isDismissed = ref(false);
    const bannerId = ref('');

    const isFeatureEnabled = computed(
      () => !props.ldFlagId || launchDarkly.getFlags()[props.ldFlagId]
    );

    const isVisible = computed(() => showBanner.value && !isDismissed.value);

    const handleClose = () => {
      isDismissed.value = true;
      if (typeof localStorage !== 'undefined' && bannerId.value) {
        const BANNER_STORAGE_KEY = `banner-dismissed-${bannerId.value}`;
        localStorage.setItem(BANNER_STORAGE_KEY, 'true');
      }
      emit('close');
    };

    (async () => {
      const res = await fetchContent(props.entryId);

      // Message is required
      message.value = res?.message;
      description.value = res?.description || '';
      variant.value = res?.variant || 'passive';
      showBanner.value = res?.showBanner;
      bannerId.value = res?.id || props.entryId;

      // Check if this banner was previously dismissed (after we have the banner ID)
      if (typeof localStorage !== 'undefined') {
        const BANNER_STORAGE_KEY = `banner-dismissed-${bannerId.value}`;
        isDismissed.value = localStorage.getItem(BANNER_STORAGE_KEY) === 'true';
      }
    })();

    return {
      message,
      description,
      isVisible,
      variant,
      isFeatureEnabled,
      handleClose,
    };
  },
});
